import { store } from '@core/store/store';
import { createAppHttpClient } from '@hwm/ui-lib';
import { environment } from '@root/environment';
import axios from 'axios';

export const httpClient = createAppHttpClient(
  () => store.getState(),
  {
    sessionCookieDomain: environment.sessionCookieDomain,
    sessionCookieIsSecure: environment.sessionCookieSecure,
    sessionIdleTimeout: environment.sessionCookieIdleTimeout,
  },
  {
    baseURL: environment.apiUrl,
  }
);

export default httpClient;

export const minioClient = createAppHttpClient(
  () => store.getState(),
  {
    sessionCookieDomain: environment.sessionCookieDomain,
    sessionCookieIsSecure: environment.sessionCookieSecure,
    sessionIdleTimeout: environment.sessionCookieIdleTimeout,
  },
  {
    baseURL: environment.apiUrl,
    noAppId: true,
  }
);

const basicClient = axios.create({
  headers: {
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
  },
});

export const simpleClient = basicClient;
